/* global google */
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import { useEffect, useMemo, useRef, useState } from 'react'
import Loader from './Spinner'

const API_KEY = process.env.REACT_APP_API_KEY_GOOGLE_MAPS
const libraries = ['places', 'geometry', 'kml']

const DEFAULT_MAP_OPTIONS = { disableDefaultUI: true, zoomControl: true }
const DEFAULT_MAP_STYLES = [
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
]
const DEFAULT_CENTER = { lat: 20.473623708878552, lng: -103.44747586737101 }
const DEFAULT_CONTAINER_STYLE = { width: '100%', height: '400px' }

export const MapPointLocationAddress = ({
  latitude,
  longitude,
  mapContainerStyle = DEFAULT_CONTAINER_STYLE,
  optionsGoogleMap = DEFAULT_MAP_OPTIONS,
  defaultCenterGoogleMap = DEFAULT_CENTER,
  stylesGoogleMap = DEFAULT_MAP_STYLES,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: API_KEY,
    libraries,
  })
  const [currentMap, setCurrentMap] = useState(null)
  // const [markerPosition, setMarkerPosition] = useState(null)

  const onLoad = async (mapInstance) => setCurrentMap(mapInstance)

  // useEffect(() => {
  //   if (latitude && longitude) {
  //     const newPosition = {
  //       lat: parseFloat(latitude),
  //       lng: parseFloat(longitude),
  //     }
  //     setMarkerPosition(newPosition)
  //     if (currentMap) {
  //       currentMap.panTo(newPosition)
  //     }
  //   }
  // }, [latitude, longitude])

  const markerPosition = useMemo(() => {
    if (latitude && longitude) {
      return { lat: parseFloat(latitude), lng: parseFloat(longitude) }
    }
    return null
  }, [latitude, longitude])

  if (loadError) {
    return <div className="alert alert-warning">Error al cargar mapa</div>
  }
  if (!isLoaded) return <Loader size="2rem" />

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      center={markerPosition || defaultCenterGoogleMap}
      zoom={markerPosition ? 18 : 14}
      options={{
        ...optionsGoogleMap,
        styles: stylesGoogleMap,
      }}
      onLoad={onLoad}
    >
      {markerPosition && <Marker position={markerPosition} />}
    </GoogleMap>
  )
}

export default MapPointLocationAddress
